<template>
  <div class="flex w-full justify-content-center">
    <div v-if="(!loaded)"><AppSpinner /></div>
    <div v-if="(loaded)" class="flex w-full">
      <div class="flex flex-column w-full gap-3">

        <div v-if="(step >= 1)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="content.txt[0].replace('#REF#', $parent.novaDenuncia_response.referencia)"></div>
            </div>
          </div>
        </div>

        <div v-if="(step >= 1)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="content.txt[1].replace('#PWD#', $parent.novaDenuncia_response.password)"></div>
            </div>
          </div>
        </div>

        <div v-if="(step >= 2)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="content.txt[2]"></div>
            </div>
          </div>
        </div>

        <div v-if="(step >= 3)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="($parent.form.novaDenuncia.emailHistorico != null && $parent.form.novaDenuncia.emailHistorico != '' ? content.txt[3] : content.txt[4])"></div>
            </div>
          </div>
        </div>

        <div v-if="(step >= ($parent.form.novaDenuncia.emailHistorico != null && $parent.form.novaDenuncia.emailHistorico != '' ? 4 : 999))" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="content.txt[4]"></div>
            </div>
          </div>
        </div>

        <div v-if="(step >= ($parent.form.novaDenuncia.emailHistorico != null && $parent.form.novaDenuncia.emailHistorico != '' ? 5 : 4))" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div class="flex flex-column w-full gap-2">
                <Button @click="fc_pdf($parent.botClient, $parent.form.novaDenuncia, $parent.novaDenuncia_response.referencia, $parent.novaDenuncia_response.password, $parent.novaDenuncia_response.data)" :label="$store.state.txt_app.bt_downloadPdf" class="app-button w-full" />
                <Button @click="mt_ecra($store.state.txt_app.bt_prazos, content.buttons.bt_prazos)" :label="$store.state.txt_app.bt_prazos" class="app-button w-full" :disabled="disabled" outlined />
              </div>
            </div>
          </div>
        </div>

        <div v-if="(step < steps && !error)" class="flex flex-column w-full">
          <div class="flex w-full justify-content-start">
            <AppThreeDots />
          </div>
        </div>

        <div v-for="(forItem, forIndex) in list" :key="forIndex" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-end">
            <div class="msg-received flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="forItem.text"></div>
            </div>
          </div>
        </div>

        <div v-if="(error.error)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent-error flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-for="(forItem, forIndex) in error.list" :key="forIndex" v-html="'<b>' + forItem.title + '</b><br/>' + forItem.msg"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: true,
      disabled: false,
      step: 0,
      steps: (this.$parent.form.novaDenuncia.emailHistorico == null || this.$parent.form.novaDenuncia.emailHistorico == '' ? 4 : 5),
      list: [],
      error: { error: false, list: [] },
    };
  },
  props: {
    name: String,
  },
  computed: {
    content() {
      return this.$store.state.txt_app[this.name];
    },
  },
  watch: {},
  methods: {
    mt_start() {
      this.mt_formPost();
    },
    mt_step() {
      this.step++;
      this.$parent.mt_goBottom();
    },
    mt_ecra(text, component, restart) {
      this.disabled = true;
      
      if (text != null && text != '') {
        let item = { text: text };
        this.list.push(item);
        this.$parent.mt_goBottom();
      }

      if (restart) {
        setTimeout(() => {
          this.$parent.mt_restart();
        }, 400);
      } else {
        let ecra = { component: component };
        this.$parent.list.push(ecra);
      }
    },
    mt_formPost() {
      this.$parent.mt_goBottom();

      let formData = new FormData();
      for (let key in this.$parent.form.novaDenuncia) {
        if (key != 'files' && this.$parent.form.novaDenuncia[key] != null) { formData.append(key, this.$parent.form.novaDenuncia[key]); }
      }
      for (let key in this.$parent.form.novaDenuncia.files) {
        formData.append('files', this.$parent.form.novaDenuncia.files[key]);
      }

      this.fc_fetch({ endpoint: 'Denuncia/' + this.$parent.botAddress + '/', method: 'POST', body: formData, formData: true, success: this.mt_formPost_success, error: this.mt_formPost_error });
    },
    mt_formPost_success(response) {
      this.$parent.novaDenuncia_response.referencia = response.item.referencia;
      this.$parent.novaDenuncia_response.password = response.item.password;
      this.$parent.novaDenuncia_response.data = response.item.dataCriacao;
      
      for (let i = 1; i <= this.steps; i++) {
        setTimeout(() => { this.mt_step(); }, (i * 400));
      }
    },
    mt_formPost_error(error) {
      this.error.error = true;
      if (error.errors && error.errorsList.length > 0) {
        this.error.list = error.errorsList;
      } else {
        this.error.list = [];
        let errorItem = { title: this.$store.state.txt_app.error_generic_title, msg: this.$store.state.txt_app.error_generic_msg };
        this.error.list.push(errorItem);
      }
      this.$parent.mt_goBottom();
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
